import { BORDER, INTER, NAVY, POPPINS, SLATE } from './verbaScholaPalette';

// Public home and login layout tokens; colors and controls come from the shared redesign palette.
export * from './verbaScholaStyles';

export const PUBLIC_PAGE_GUTTER = { xs: 2, sm: 3, md: 4 } as const;
export const PUBLIC_CONTENT_MAX_WIDTH = 1120;

export const publicCardSx = {
    backgroundColor: '#FFFFFF',
    border: `1px solid ${BORDER}`,
    borderRadius: '20px',
} as const;

export const publicSectionTitleSx = {
    fontFamily: POPPINS,
    fontWeight: 600,
    fontSize: { xs: 24, md: 30 },
    lineHeight: 1.25,
    color: NAVY,
} as const;

export const publicSectionLeadSx = {
    fontFamily: INTER,
    fontSize: { xs: 15, md: 17 },
    lineHeight: 1.6,
    color: SLATE,
} as const;

// Teacher accounts are granted by VerbaSchola or a co-teacher invitation, not self-registration.
export const PILOT_REQUEST_HREF = '/pilot';
export const SUPPORT_EMAIL = 'support@verbaschola.com';
